import Delete from "../svgs/formBuild/Delete"

const UploadedFile = ({ filename, onDelete }) => {
  return (
    <span className='bg-green_50 text-green text-sm font-medium underline capitalize border border-green_200 p-8 rounded-lg flex items-center ltr:ml-8 rtl:mr-8 first:ltr:ml-0 first:rtl:mr-0 mb-8'>
      {filename}
      <Delete
        style={`ltr:ml-16 rtl:mr-16 w-16 cursor-pointer`}
        onClick={onDelete}
      />
    </span>
  )
}

export default UploadedFile
